import localFont from 'next/font/local'

const IranSansXFont = localFont({
	src: [
		{ path: './thin.woff2', weight: '100', style: 'normal' },
		{ path: './ultra-light.woff2', weight: '200', style: 'normal' },
		{ path: './light.woff2', weight: '300', style: 'normal' },
		{ path: './regular.woff2', weight: '400', style: 'normal' },
		{ path: './medium.woff2', weight: '500', style: 'normal' },
		{ path: './demi-bold.woff2', weight: '600', style: 'normal' },
		{ path: './bold.woff2', weight: '700', style: 'normal' },
		{ path: './extra-bold.woff2', weight: '800', style: 'normal' },
		{ path: './black.woff2', weight: '900', style: 'normal' },
		{ path: './extra-black.woff2', weight: '950', style: 'normal' },
		{ path: './heavy.woff2', weight: '1000', style: 'normal' }
	],
	display: 'swap',
	// Not preloaded: the browser then downloads only the weights a page actually uses, instead of every file up front
	preload: false
})

export default IranSansXFont
